import { Link, useLocation } from "react-router-dom";
import useDocumentMeta from "@/hooks/useDocumentMeta";

export default function NotFound() {
  const location = useLocation();

  useDocumentMeta({
    title: "页面未找到 - 51无敌电影网",
    description: "你访问的页面不存在，请返回首页或浏览电影、电视剧频道继续观看。",
    keywords: "404,页面未找到,51无敌电影网",
  });

  return (
    <div className="w-full px-4 md:px-6 py-24 flex flex-col items-center justify-center text-center">
      <p className="text-7xl md:text-9xl font-heading font-bold text-primary-200 select-none">404</p>
      <h1 className="mt-4 text-xl md:text-2xl font-heading font-semibold text-foreground-900">
        你访问的页面不存在
      </h1>
      <p className="mt-2 text-sm text-foreground-500 break-all">{location.pathname}</p>
      <div className="mt-7 flex flex-wrap items-center justify-center gap-3">
        <Link
          to="/"
          className="px-6 py-2.5 rounded-md bg-primary-500 hover:bg-primary-600 text-background-50 text-sm font-label font-semibold transition-colors cursor-pointer whitespace-nowrap"
        >
          返回首页
        </Link>
        <Link
          to="/category/movie"
          className="px-6 py-2.5 rounded-md border border-background-200 text-foreground-700 hover:bg-background-100 text-sm font-label font-semibold transition-colors cursor-pointer whitespace-nowrap"
        >
          浏览电影频道
        </Link>
      </div>
    </div>
  );
}